module.exports = __webpack_public_path__ + "static/media/AccessibilityIcon.60b808fc.svg";